export default {"src":"/_next/static/media/switch-native.cb58b892.svg","height":28,"width":28};